import { createStore, Store } from 'vuex';

import auth from './auth';
import plans from './plans';
import notifications from './notifications';
import subscriptions from './subscriptions';
import invoices from './invoices';
import services from './services';
import payments from './payments';

import { state, RootStateI } from './state';
import { mutations } from './mutations';

const store: Store<RootStateI> = createStore({
  state,
  getters: {
  },
  mutations,
  actions: {
  },
  modules: {
  },
});

store.registerModule('subscriptions', subscriptions);
store.registerModule('notifications', notifications);
store.registerModule('invoices', invoices);
store.registerModule('services', services);
store.registerModule('payments', payments);
store.registerModule('plans', plans);
store.registerModule('auth', auth);

export default store;
